{
  "buttons": {
    "actions": "Actions",
    "add": "Add",
    "apply": "Apply",
    "archive": "Archive",
    "cancel": "Cancel",
    "clear": "Clear",
    "close": "Close",
    "create": "Create",
    "connect": "Connect",
    "decline": "Decline",
    "delete": "Delete",
    "download": "Download",
    "edit": "Edit",
    "export": "Export",
    "next": "Next ->",
    "publish": "Publish",
    "remove": "Remove",
    "resend": "Resend",
    "save": "Save",
    "select": "Select",
    "submit": "Submit",
    "transfer": "Transfer",
    "validate": "Validate",
    "view": "View"
  },
  "deletedUser": "Deleted user",
  "excludedTax": "excl. tax",
  "fields": {
    "accountNumber": {
      "label": "Account number"
    },
    "bankCode": {
      "label": "Bank code"
    },
    "bankCountryCode": {
      "label": "Bank country code"
    },
    "bicSwift": {
      "label": "BIC/SWIFT"
    },
    "billingAddress": {
      "label": "Billing address"
    },
    "budget": {
      "label": "Budget",
      "placeholder": "Select a budget"
    },
    "city": {
      "label": "City"
    },
    "citySearch": {
      "error": "An error occured while searching cities",
      "placeholder": "Paris, Barcelone, Berlin…"
    },
    "comment": {
      "label": "Comment",
      "placeholder": "Write your comment…"
    },
    "country": {
      "label": "Country"
    },
    "currency": {
      "label": "Currency"
    },
    "date": {
      "label": "Date",
      "placeholder": "Select a date",
      "tooltip": "Tight deadlines can be challenging, we will do our best to make it happen but can't promise anything."
    },
    "dateTime": {
      "label": "Date & Time"
    },
    "description": {
      "label": "Description"
    },
    "email": {
      "label": "Email",
      "placeholder": "john.doe@acme.com"
    },
    "eventName": {
      "error": "Event name is required",
      "label": "Event name",
      "placeholder": "Q4 Sales Kickoff"
    },
    "eventType": {
      "error": "Event type is required",
      "label": "Event type",
      "placeholder": "Select a type"
    },
    "fileDocument": {
      "attachmentTypes": "PDF, JPEG, or CSV",
      "documentTypes": "PDF, JPEG or PNG",
      "label": "Choose a file to upload"
    },
    "firstName": {
      "label": "First name",
      "placeholder": "First name"
    },
    "iban": {
      "label": "IBAN number"
    },
    "inOurOffice": {
      "label": "In our office"
    },
    "lastName": {
      "label": "Last name",
      "placeholder": "Last name"
    },
    "legalCompanyName": {
      "label": "Legal company name"
    },
    "location": {
      "helperText": "Select the city for the event timezone",
      "label": "Location"
    },
    "name": {
      "label": "Name"
    },
    "office": {
      "label": "Office",
      "placeholder": "Select an office",
      "another": "Other office"
    },
    "officeAddress": {
      "label": "Office address",
      "placeholder": "32 Guild Street, E5 0ZF London"
    },
    "participants": {
      "label": "Participants",
      "placeholder": "Number of participants"
    },
    "phoneNumber": {
      "helper": "In international format, ex: +22 607 123 4567",
      "label": "Phone number"
    },
    "postalCode": {
      "label": "Postal code"
    },
    "preferredCurrency": {
      "label": "Preferred currency"
    },
    "provider": {
      "helperText": "Please select location first",
      "label": "Select a provider",
      "placeholder": "Search provider by name"
    },
    "registrationNumber": {
      "label": "Registration number"
    },
    "routingNumber": {
      "label": "ABA routing number"
    },
    "state": {
      "label": "State"
    },
    "status": {
      "label": "Status"
    },
    "street": {
      "label": "Street"
    },
    "time": {
      "label": "Time",
      "placeholder": "Select a time"
    },
    "usersSearch": {
      "placeholder": "Search a user"
    },
    "vatNumber": {
      "label": "VAT number"
    },
    "website": {
      "label": "Website"
    }
  },
  "jurneeTeam": "Jurnee team",
  "link": "Link",
  "login": {
    "sso": {
      "buttons": {
        "continue": "Continue with SSO",
        "login": "Login with this email"
      },
      "errors": {
        "AUTHORIZATION_FAILED": "Single sign on is not configured for your workspace or you do not have access to Jurnee",
        "TOKEN_FAILED": "Unable to recover your connection token"
      }
    }
  },
  "no": "No",
  "or": "or",
  "people": "people",
  "settings": "Settings",
  "status": {
    "approved": "approved",
    "canceled": "canceled",
    "open": "to pay",
    "paid": "paid",
    "pending": "pending",
    "rejected": "rejected",
    "signed": "signed"
  },
  "virtual": "Virtual",
  "yes": "Yes"
}